import angular from "angular";
import core from "../../core/core.module";
import uiMask from "angular-ui-mask";
import user from "../../users-control/user";

let mod = angular.module('RegisterRequest.acceptedRegisterRequest', [core, uiMask, user])
    .component('acceptedRegisterRequest', {
        controller: ['notifier', 'Data', 'User', controller],
        template: require('./accepted-register-request.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(notifier, Data, User) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.agregator = $ctrl.resolve.agregator;
        $ctrl.roles = window.angular.copy($ctrl.resolve.roles);
        $ctrl.registerRequest = $ctrl.resolve.registerRequest;

        $ctrl.lastName = null;
        $ctrl.firstName = null;
        $ctrl.email = null;
        $ctrl.phone = null;
        $ctrl.position = null;
        $ctrl.type = null;
        $ctrl.organization = null;
        $ctrl.code = null;
        $ctrl.organizationBin = null;

        setData();
    };

    function setData() {
        let r = $ctrl.registerRequest;
        $ctrl.lastName = r.last_name;
        $ctrl.firstName = r.first_name;
        $ctrl.email = r.email;
        $ctrl.phone = r.phone;
        $ctrl.position = r.position;
        $ctrl.organization = r.organization;
        $ctrl.organizationBin = r.organization_bin;
        if (r.organization) {
            $ctrl.type = (r.organization.is_main) ? 'owner' : 'customer';
        }
    }

    $ctrl.getOrganizations = function (fragment) {
        return Data.getOrganizations(fragment);
    };

    $ctrl.selectRole = function (role) {
        role.isSelected = !role.isSelected;
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let rolesIds = [];
        for (let i = 0; i < $ctrl.roles.length; i++) {
            if ($ctrl.roles[i].isSelected) {
                rolesIds.push($ctrl.roles[i].id)
            }
        }

        User
            .store({
                register_request_id: $ctrl.registerRequest.id,
                last_name: $ctrl.lastName,
                first_name: $ctrl.firstName,
                email: $ctrl.email,
                phone: $ctrl.phone,
                type: $ctrl.type,
                organization_id: $ctrl.type == 'owner' ? $ctrl.agregator.id : $ctrl.organization.id,
                position: $ctrl.position,
                code: $ctrl.code,
                roles_ids: rolesIds,
            })
            .then(
                function (response) {
                    let id = response.data.id;
                    notifier.successNotify('Пользователь успешно добавлен', 2000);
                    $ctrl.loading = false;
                    $ctrl.close({$value: {id: id}});
                },
                function (error) {
                    $ctrl.loading = false;
                    notifier.errorResponseNotify(error);
                }
            );
    };

}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/register-requests-control/accepted-register-request/accepted-register-request.js